const colors = {
  green: '#00873D',
  greenPale: '#0AAF54',
  red: '#DC423F',
  redPale: '#F05551',
  blue: '#3F8AB3',
  bluePale: '#469DCD',
  blueDark: '#005DB9',

  // greyscale
  grey100: '#ffffff',
  grey98: '#FBFBFB',
  grey95: '#F2F2F2',
  grey90: '#E6E6E6',
  grey85: '#D9D9D9',

  grey55: '#8C8C8C',

  grey45: '#737373',
  grey30: '#4D4D4D',
  grey25: '#404040',
  grey20: '#333333',
  grey15: '#262626',
  grey10: '#1A1A1A',
  grey5: '#0E0E0E',
  grey0: '#000000',
};

export default colors;
